import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CommonDataService} from 'app/services/common-data.service';
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {ITabInfo} from "../../models/tab-info-interface";
import {TabInfoBase} from "../../models/tab-info-base";
import {BGChartType} from "../../models/b-g-chart-type";

@Component({
    selector: 'tabs-header',
    templateUrl: './tabs-header.component.html',
    styleUrls: ['./tabs-header.component.css']
})
export class TabsHeaderComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                public readonly commonData: CommonDataService,
                ){
        this.helper = new ChartHelper();
        this.close = new EventEmitter<ITabInfo>();
        this.updateState = new EventEmitter<boolean>();
        // this.tooltipFunc = new Function('cell', '$("[data-toggle=tooltip]", cell).tooltip({ boundary: "window" });');
    }

    private _dateChanged: boolean;
    @Input()
    set dateChanged(val: boolean) {
        if (val !== this.dateChanged){
            this._dateChanged = val;
        }
    };

    get dateChanged(): boolean {
        return this._dateChanged;
    };

    @Input() public tabHeader: TabInfoBase<any>;
    @Input() public GUID: string;
    @Input() public chartType: BGChartType;

    @Output()
    private readonly close: EventEmitter<ITabInfo>;

    @Output()
    public readonly updateState: EventEmitter<boolean>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('tooltipEl')
    private tooltipEl: ElementRef;

    private helper: ChartHelper;

    public tooltip: string;

    public initialized: boolean;

    public translates: {[key: string]: string};

    private tooltipFunc: Function;
    // private popperAddVar: Popper;
    // private listenContextMenu: () => void;
    // private listenMouseDown: () => void;

    async ngOnInit(){
        this.tabHeader.customRowHeight = this.helper.readFromLocalStorageJSON(this.tabHeader.id)
        // console.log(this.tabHeader.customRowHeight, 'this.tabHeader.customRowHeight')
        this.translates = await this.translateService.get(['Warehouse', 'SKU', 'Period', 'WrapWordsInCell']).toPromise();
        await this.generateTooltip();
        this.initialized = true;
    }

    ngOnDestroy(){

    }

    ngAfterViewInit(){
        this.helper.wait(() => $(this.tooltipEl.nativeElement).tooltip({template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner large"></div></div>'}), 50);
    }

    //# close tab
    public removeTab = (tab: ITabInfo): void =>{
        this.close.emit(tab);
    }

    //# generate tooltip
    private generateTooltip = async (): Promise<void> => {
        let header = await this.translateService.get(this.tabHeader.header).toPromise();
        const hide = (): string => this.chartType === BGChartType.Summary ? 'd-none' : '';
        this.tooltip = `<div class="text-truncate" style="width: 350px">
                            <span>${header}</span><br/>
                            ${!hide() ? `<span>${this.translates.Warehouse}: ${this.tabHeader.itemInfo.warehouseCode} ${this.tabHeader.itemInfo.warehouseName}</span><br/>`: ''}
                            ${!hide() ? `<span>${this.translates.SKU}: ${this.tabHeader.itemInfo.sku} ${this.tabHeader.itemInfo.name}</span><br/>`: ''}
                            <span>${this.translates.Period}: ${this.tabHeader.startDate.format(this.helper.ru_Date)}-${this.tabHeader.endDate.format(this.helper.ru_Date)}</span>
                       </div>`;
    }

    /**
     * update custom row height settings in tab
     */
    public readonly updateCustomRowHeight = (): void => {
        this.tabHeader.customRowHeight = !this.tabHeader.customRowHeight
        // console.log(this.tabHeader.customRowHeight, 'updateCustomRowHeight')
        this.updateState.emit(this.tabHeader.customRowHeight)
        this.helper.saveToLocalStorageJSON(this.tabHeader.id, this.tabHeader.customRowHeight)
    }
}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/tabs-header.component/tabs-header.component.ts